import { Component } from '@theme/component';

/**
 * Builds two equal announcement groups so the CSS marquee can loop seamlessly.
 * The first occurrence of each merchant-managed block remains interactive and
 * accessible; visual repetitions are removed from the accessibility tree.
 */
export class AnnouncementBar extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#buildMarquee();
  }

  #buildMarquee() {
    if (this.classList.contains('is-ready')) return;

    const source = this.querySelector('.announcement-bar__source');
    const track = this.querySelector('.announcement-bar__track');
    if (!(source instanceof HTMLElement) || !(track instanceof HTMLElement)) return;

    const slides = Array.from(source.children).filter((element) =>
      element.classList.contains('announcement-bar__slide')
    );
    if (slides.length === 0) return;

    const repetitions = slides.length === 1 ? 6 : slides.length === 2 ? 4 : slides.length <= 4 ? 3 : 2;
    const primaryGroup = document.createElement('div');
    primaryGroup.className = 'announcement-bar__group';

    for (let repetition = 0; repetition < repetitions; repetition += 1) {
      slides.forEach((slide) => {
        const item = repetition === 0 ? slide : slide.cloneNode(true);
        this.#prepareItem(item, repetition !== 0);
        primaryGroup.append(item);
      });
    }

    const duplicateGroup = primaryGroup.cloneNode(true);
    duplicateGroup.setAttribute('aria-hidden', 'true');
    duplicateGroup.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
      element.removeAttribute('data-shopify-editor-block');
    });
    duplicateGroup.querySelectorAll('a').forEach((link) => {
      link.setAttribute('tabindex', '-1');
      link.setAttribute('aria-hidden', 'true');
    });

    track.replaceChildren(primaryGroup, duplicateGroup);
    source.remove();
    this.classList.add('is-ready');
  }

  /**
   * @param {Element} item
   * @param {boolean} isDuplicate
   */
  #prepareItem(item, isDuplicate) {
    item.classList.add('announcement-bar__item');
    item.removeAttribute('ref');

    if (isDuplicate) {
      item.setAttribute('aria-hidden', 'true');
      item.removeAttribute('data-shopify-editor-block');
      item.querySelectorAll('a').forEach((link) => {
        link.setAttribute('tabindex', '-1');
        link.setAttribute('aria-hidden', 'true');
      });
    } else {
      item.removeAttribute('aria-hidden');
    }
  }
}

if (!customElements.get('announcement-bar-component')) {
  customElements.define('announcement-bar-component', AnnouncementBar);
}
